import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {mt} from "@pg-design/helpers-css";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {pulseHeartbeatAnimation} from "../../../app/styles/animations";

interface IProps {
    // For styling map button
    className?: string;
    isMap?: boolean;
    linkUrl: string;
}

export const ToggleMapButton = (props: IProps) => {
    const theme = useTheme();

    return props.isMap ? (
        <a href={props.linkUrl}>Lista</a>
    ) : (
        <a href={props.linkUrl} className={props.className} css={mapLinkStyle}>
            <span>
                <BrandMapPinIcon size="10" wrapperType="circle" wrapperSize="10" wrapperColor={theme.colors.primary} />
            </span>
            <Text variant="button_medium" strong css={textStyle}>
                Zobacz na mapie
            </Text>
        </a>
    );
};

const mapLinkStyle = (theme: Theme) => css`
    display: none;
    ${pulseHeartbeatAnimation("2.5s", "infinite")};

    @media (min-width: ${theme.breakpoints.md}) {
        margin-top: -3.6rem; // offest top by height of the breadcrumbs component
        align-items: center;
        display: flex;
        flex-direction: column;
        line-height: 1.4;
        color: ${theme.colors.secondary};

        &:visited,
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.secondary};
            text-decoration: none;
        }
    }
`;

const textStyle = css`
    text-transform: uppercase;
    ${mt(2)};
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {mt} from "@pg-design/helpers-css";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {pulseHeartbeatAnimation} from "../../../app/styles/animations";

interface IProps {
    // For styling map button
    className?: string;
    isMap?: boolean;
    linkUrl: string;
}

export const ToggleMapButton = (props: IProps) => {
    const theme = useTheme();

    return props.isMap ? (
        <a href={props.linkUrl}>Lista</a>
    ) : (
        <a href={props.linkUrl} className={props.className} css={mapLinkStyle}>
            <span>
                <BrandMapPinIcon size="10" wrapperType="circle" wrapperSize="10" wrapperColor={theme.colors.primary} />
            </span>
            <Text variant="button_medium" strong css={textStyle}>
                Zobacz na mapie
            </Text>
        </a>
    );
};

const mapLinkStyle = (theme: Theme) => css`
    display: none;
    ${pulseHeartbeatAnimation("2.5s", "infinite")};

    @media (min-width: ${theme.breakpoints.md}) {
        margin-top: -3.6rem; // offest top by height of the breadcrumbs component
        align-items: center;
        display: flex;
        flex-direction: column;
        line-height: 1.4;
        color: ${theme.colors.secondary};

        &:visited,
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.secondary};
            text-decoration: none;
        }
    }
`;

const textStyle = css`
    text-transform: uppercase;
    ${mt(2)};
`;
